<mat-card class="template-card__card">
  <div fxLayout="column" fxLayoutAlign="space-between center" class="template-card__meta-container">
    <div fxLayout="column" fxLayoutAlign="center center" class="template-card__image-container">
      <img alt="Template Image" class="template-card__image" [src]="imageUrl">
    </div>
    <mat-divider class="template-card__divider"></mat-divider>
    <div class="template-card__item-name-wrapper" [attr.data-testid]="name + '-event'">
      <p class="template-card__item-name">{{name}}</p>
    </div>
    <div class="template-card__description">
      <span [innerHTML]="description"></span>
    </div>
  </div>
</mat-card>
